import { Backdrop, Stack, Theme } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import Loader from '../loader';
import OrgLogo from '../org-logo';
import { getCachedOrgBranding } from '@/lib/services/org.service';

const useStyles = createUseStyles((theme: Theme) => ({
  loader: {
    zIndex: theme.zIndex.drawer + 1000,
    backgroundColor: theme.palette.background.default,
  },
}));

const PageLoader: FC = () => {
  const styles = useStyles();

  /*
   * This component is unique because it appears before the app context is loaded, which means it appears before
   * authentication is verified and basic user and org information are available. Therefore, in order to prevent
   * the user from briefly seeing branding that may not match, only show the org logo if it's cached, implying it
   * was loaded from org service once before and is "correct". The limitation here is that in effect, the user will
   * not see the logo (1) on very first load, (2) if the org has no branding.
   */
  const hasCachedBranding = !!getCachedOrgBranding();

  return (
    <Backdrop className={styles.loader} open={true}>
      <Stack gap={3} alignItems="center" justifyContent="center" width="300px">
        {hasCachedBranding && <OrgLogo />}
        <Loader />
      </Stack>
    </Backdrop>
  );
};

export default PageLoader;
